const Header = ({ isDarkMode, onToggleDarkMode }) => {
    return (
        <header className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-md shadow-sm border-b dark:border-gray-700">
            <div className="max-w-7xl mx-auto px-10 sm:px-14 py-4 sm:py-6 flex justify-between items-center">
                <div className="flex items-center space-x-3">
                    <img
                        src={isDarkMode ? "/logo_dark.svg" : "/logo.svg"}
                        alt="ShrinkR Logo"
                        className="w-8 h-8 sm:w-10 sm:h-10"
                    />
                    <div>
                        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white">
                            ShrinkR
                        </h1>
                        <p className="text-gray-600 dark:text-gray-300 mt-1 text-sm sm:text-base">
                            Make your URLs shorter and shareable
                        </p>
                    </div>
                </div>

                <button
                    onClick={onToggleDarkMode}
                    className="p-2 rounded-lg bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors duration-200"
                    title="Toggle dark mode"
                >
                    <svg
                        className="w-5 h-5 text-yellow-500 hidden dark:block"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                    >
                        <path
                            fillRule="evenodd"
                            d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                            clipRule="evenodd"
                        />
                    </svg>

                    <svg
                        className="w-5 h-5 text-gray-700 dark:hidden"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                    >
                        <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
                    </svg>
                </button>
            </div>
        </header>
    );
};

export default Header;
